import { Link } from "@tanstack/react-router";
import { SectionHeading } from "@/components/ui-ext/SectionHeading";
import { Reveal } from "@/components/ui-ext/Reveal";
import { industryVariantKey } from "@/content/imagery";
import { Picture } from "@/components/media/Picture";

const INDUSTRIES = [
  { t: "Automotive & Auto Repair", slug: "automotive", d: "European specialists, dealer groups and independent service centers across Austin, Round Rock and Cedar Park — local pack dominance, service-intent pages, and Google review velocity." },
  { t: "HVAC & Home Services", slug: "hvac-home-services", d: "HVAC, roofing, plumbing and electricians serving Austin, Pflugerville, Georgetown and Leander — service-area pages, GBP category dominance, and seasonal Texas heat & storm content engines." },
  { t: "Security & Automation", slug: "security-automation", d: "Commercial security integrators covering Central Texas — technical service pages, industry clusters, and LocalBusiness schema at scale." },
  { t: "B2B SaaS", slug: "saas", d: "Austin's SaaS corridor from the Domain to East Austin — bottom-of-funnel commercial pages, integration hubs, comparison content and AI-Overview citation strategy." },
  { t: "Professional Services", slug: "professional-services", d: "Austin legal, accounting and consulting firms — trust content, structured author entities, expertise signaling and E-E-A-T proof for high-stakes queries." },
  { t: "eCommerce", slug: "ecommerce", d: "Category and PLP optimization, product schema, faceted-navigation architecture and technical SEO for Texas retail and DTC brands scaling nationally." },
];

export function HomeIndustries() {
  return (
    <section className="container-page py-16 md:py-24">
      <SectionHeading
        eyebrow="Industry focus · Austin & Central Texas"
        title={<>We only work in categories where we've <span className="text-gradient">already won locally</span>.</>}
        intro="Deep vertical expertise beats surface-level SEO knowledge every time. Here are the Austin and Central Texas categories where Optimize Plus has built repeatable, documented playbooks."
      />
      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {INDUSTRIES.map((s, i) => (
          <Reveal key={s.t} delay={(i % 4) as 0 | 1 | 2 | 3}>
            <Link
              to="/industries/$slug/"
              params={{ slug: s.slug }}
              className="surface-card overflow-hidden h-full flex flex-col hover-lift group"
            >
              <div className="aspect-[16/10] overflow-hidden bg-surface-2">
                <Picture
                  variantKey={industryVariantKey(s.slug)}
                  alt={`${s.t} SEO in Austin, Texas — Optimize Plus case work`}
                  imgClassName="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  sizes="(min-width: 1024px) 380px, (min-width: 768px) 340px, 320px"
                />
              </div>
              <div className="p-6 flex-1">
                <h3 className="font-display text-lg leading-tight">{s.t}</h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
